import axios from 'axios'
import auth from '@/auth/index'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.request.use((config) => {
  if (auth.isLogged()) {
    config.headers.Authorization = `Bearer ${auth.getTokenLogged()}`
  }
  return config
})

function assertResult (response) {
  const result = response && response.data ? response.data.result : null
  if (result !== 'OK' && result !== true) {
    throw new Error((response && response.data && response.data.message) || 'Operación no completada')
  }
}

export default {
  async getCompanyNotes (companyId) {
    const response = await api.get('company/getNotes', { params: { company_id: companyId } })
    return response.data.notes || []
  },

  async createCompanyNote (payload) {
    const response = await api.post('company/createNote', { note: payload })
    assertResult(response)
    return response.data.note
  },

  async getCompanyTasks (companyId) {
    const response = await api.get('company/getTasks', { params: { company_id: companyId } })
    return response.data.tasks || []
  },

  async createCompanyTask (payload) {
    const response = await api.post('company/createTask', { task: payload })
    assertResult(response)
    return response.data.task
  },

  async updateCompanyTask (payload) {
    const response = await api.post('company/updateTask', { task: payload })
    assertResult(response)
    return response.data.task
  },

  async changeCompanyTaskStatus (payload) {
    const response = await api.post('company/changeTaskStatus', { task: payload })
    assertResult(response)
    return response.data.task
  },

  async getMyAssignedTasks () {
    const response = await api.get('tasks/myAssigned')
    if (!response.data || !Array.isArray(response.data.tasks)) {
      throw new Error('El servidor no devolvió la lista de tareas. Verifica que la aplicación y la API estén actualizadas.')
    }
    return response.data.tasks
  },

  async getMyAssignedTasksCount () {
    const response = await api.get('tasks/myAssignedCount')
    return response.data.count || 0
  },

  async getGeneralTracking (params = {}) {
    const response = await api.get('tracking/general', { params })
    return response.data.items || []
  }
}
